export default {
  list: {
    columns: [
      { key: 'key', width: 200 },
      { key: 'name', width: 300 },
      { key: 'brandCode', width: 100 },
      { key: 'supplierRef', width: 150 },
      { key: 'salePrice', width: 100 },
    ],
    query: {
      fixedQuery: {
        type: { $eq: 'F' },
      },
    },
  },
  editor: {
    config: { titleSm: 2, titleMd: 1 },
    groups: [
      {
        name: '商品',
        rows: [
          [{ key: 'key' }],
          [{ key: 'name' }],
          [{ key: 'type' }],
          [{ key: 'brandCode' }, { key: 'brandRef' }],
          [{ key: 'supplierRef' }, { key: 'orderCode' }],
          [{ key: 'unit' }],
          [{ key: 'origin' }],
          [{ key: 'note' }],
          [{ key: 'isContract' }],
          [{ key: 'orderFrom' }],
          [{ key: 'payType' }],
          [{ key: 'spec' }],
          [{ key: 'taxType' }],
          [{ key: 'basicAmount' }],
          [{ key: 'ragicStoreNodeId' }, { key: 'ragicCenterNodeId' }],
        ],
      },
      {
        name: '成本',
        rows: [
          [{ key: 'centerCost' }],
          [{ key: 'storeCost' }],
        ],
      },
      {
        name: '價格',
        rows: [
          [{ key: 'price' }],
          [{ key: 'staffPrice' }],
          [{ key: 'salePrice' }],
        ],
      },
    ],
  },
}



// WEBPACK FOOTER //
// ./src/views/ui/productsF.js